import { render, staticRenderFns } from "./CanditeReservations.vue?vue&type=template&id=f021cd6a&scoped=true&lang=pug&"
import script from "./CanditeReservations.vue?vue&type=script&lang=js&"
export * from "./CanditeReservations.vue?vue&type=script&lang=js&"
import style0 from "./CanditeReservations.vue?vue&type=style&index=0&id=f021cd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f021cd6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
